/* eslint-disable no-useless-catch */
import $api from '../config/api'

export const getProfileInfo = async () => {
  try {
    const response = await $api.get('/users/profile')
    return response.data
  } catch (error) {
    throw error
  }
}

export const getPageInfo = async (userId: string) => {
  try {
    const response = await $api.get(`/users/${userId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getProfilePlan = async () => {
  try {
    const response = await $api.get('/users/profile/plan')
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateProfileInfo = async (reqData: UserIdentity) => {
  try {
    const response = await $api.patch('/users/profile', reqData)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteUserAvatar = async () => {
  try {
    const response = await $api.delete('/users/profile/avatar')
    return response
  } catch (error) {
    throw error
  }
}

export const uploadUserAvatar = async (formData: FormData) => {
  try {
    const response = await $api.put('/users/profile/avatar', formData)
    return response
  } catch (error) {
    throw error
  }
}

export const deleteUserProfile = async () => {
  try {
    const response = await $api.delete('/users/profile')
    return response.data
  } catch (error) {
    throw error
  }
}
